export type AuthorityName = 'LUBE_ADMIN' | 'LUBE_GLOBAL_VIEWER' | 'LUBE_EDITOR' | 'LUBE_VIEWER';

export const ROLES = {
  ADMIN: 'LUBE_ADMIN',
  GLOBAL_VIEWER: 'LUBE_GLOBAL_VIEWER',
  EDITOR: 'LUBE_EDITOR',
  VIEWER: 'LUBE_VIEWER',
} as const;

// Simple helpers
export const isAdmin = (role?: AuthorityName) => role === ROLES.ADMIN;
export const isGlobalViewer = (role?: AuthorityName) => role === ROLES.GLOBAL_VIEWER;
export const isEditor = (role?: AuthorityName) => role === ROLES.EDITOR;
export const isViewer = (role?: AuthorityName) => role === ROLES.VIEWER;
